import { render, staticRenderFns } from "./notices.vue?vue&type=template&id=313016ea&scoped=true&"
import script from "./notices.vue?vue&type=script&lang=js&"
export * from "./notices.vue?vue&type=script&lang=js&"
import style0 from "./notices.vue?vue&type=style&index=0&id=313016ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313016ea",
  null
  
)

component.options.__file = "notices.vue"
export default component.exports